import ExpiredAsset from "./ExpiredAsset.tsx";
import { useExpiredFetcher } from "./expiredLoader.ts";
import { useEffect, useRef } from "react";
import { Fetcher } from "react-router-dom";
import useUserPreference from "../actions/user/useUserPreference.ts";
import { UserPreferenceKey } from "../../../common/api/decimal/methods/user.ts";
import { useExpiredNotify } from "../common/expired/useExpiredNotify.ts";

export function LoadableExpiredAssetChunk({
  onSetFetcher,
}: {
  onSetFetcher: (fetcher: Fetcher) => void;
}) {
  // Product/design say it's fine to only load 100 items max
  const page = 1;
  const fetcher = useExpiredFetcher();
  const { unseenExpiredCount } = useExpiredNotify();
  const [_lastSeenExpiredAt, setLastSeenExpiredAt] = useUserPreference<string>(
    UserPreferenceKey.LastSeenExpiredAt
  );
  const sentLastSeenExpiredAt = useRef(false);

  useEffect(() => {
    onSetFetcher(fetcher);
  }, [onSetFetcher, fetcher]);

  useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      void fetcher.load(`/expired/assets/${page}`);
    }
  }, [fetcher, page]);

  useEffect(() => {
    if (
      fetcher.data &&
      fetcher.data.ok &&
      !sentLastSeenExpiredAt.current &&
      unseenExpiredCount > 0
    ) {
      // when user sees expired titles, record the datetime to remove expired notification in sidebar
      // only want to do this once when we know they actually loaded (i.e. they probably saw them)
      sentLastSeenExpiredAt.current = true;
      setLastSeenExpiredAt(new Date().toISOString());
    }
  }, [
    fetcher.data,
    sentLastSeenExpiredAt,
    setLastSeenExpiredAt,
    unseenExpiredCount,
  ]);

  if (fetcher.data && fetcher.data.ok && fetcher.data.data) {
    return fetcher.data.data.map((asset) => (
      <ExpiredAsset key={asset.manageAsset.vbid} asset={asset} />
    ));
  }
}
